import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';

import { environment } from '../../environments/environment';
import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { KeypadDialogComponent } from '../dialogs/keypad-dialog/keypad-dialog.component';
import { BottomSheetDialogComponent } from '../dialogs/bottom-sheet-dialog/bottom-sheet-dialog.component';
import { PassorderDialogComponent } from 'src/app/tabit-pay/_dialogs/passorder-dialog/passorder-dialog.component';
import { OrderViewDialogComponent } from 'src/app/tabit-pay/_dialogs/order-view-dialog/order-view-dialog.component';
import { OfferSelectDialogComponent } from 'src/app/tabit-pay/_dialogs/offer-select-dialog/offer-select-dialog.component';
import { PaybyDinersDialogComponent } from 'src/app/tabit-pay/_dialogs/payby-diners-dialog/payby-diners-dialog.component';
import { SmsDialogComponent } from '../dialogs/sms-dialog/sms-dialog.component';
import { PaySuccessDialogComponent } from 'src/app/tabit-pay/_dialogs/pay-success-dialog/pay-success-dialog.component';

import { LoginDialogComponent } from '../login/login-dialog/login-dialog.component';
import { AccountDialogComponent } from '../login/account-dialog/account-dialog.component';
import { HistoryDialogComponent } from "../login/history-dialog/history-dialog.component";
import { WalletDialogComponent } from "../login/wallet-dialog/wallet-dialog.component";
import { SignupPromptDialogComponent } from 'src/app/tabit-pay/_dialogs/signup-prompt-dialog/signup-prompt-dialog.component';
import { TabitpayCheckDialogComponent } from '../tabit-pay/tabitpay-ticket/tabitpay-check-dialog/tabitpay-check-dialog.component';
import { TabitpayDinerDialogComponent } from '../tabit-pay/tabitpay-ticket/tabitpay-diner-dialog/tabitpay-diner-dialog.component';
import { OrderLoyaltyComponent  } from 'src/app/tabit-order/order-loyalty/order-loyalty.component';

import { TabOptionsBottomsheetComponent } from '../dialogs/tab-options-bottomsheet/tab-options-bottomsheet.component';
import { FullFrameDialogComponent } from "../dialogs/full-frame-dialog/full-frame-dialog.component";
import { TableNumberDialogComponent  } from '../dialogs/table-number-dialog/table-number-dialog.component';
import { OfferRequestDialogComponent } from 'src/app/tabit-pay/_dialogs/offer-request-dialog/offer-request-dialog.component';

import * as _ from 'lodash';

@Injectable({
	providedIn: 'root'
})
export class DialogsService {

    appConfig = environment.appConfig;

	constructor(
		private router: Router,
		public appService: AppService,
		public entityService: EntityService,
		public dialog: MatDialog,
        private bottomSheet: MatBottomSheet,
        //private router: Router,
	) {

	}

	public toggleActionFrame(action, siteDetails, event?, fromSite?) {
		if (event) event.stopPropagation();
		switch (action) {
			case "bill":
				const url = `${this.appConfig.tabitBillURL}/receipt?o=${siteDetails.organization}&t=${siteDetails._id}&p=&c=`;
				//window.open(url)
				let dialogRef = this.dialog.open(FullFrameDialogComponent, {
					panelClass: 'fullscreen-dialog',
					direction: this.appService.direction,
					autoFocus: false,
					data: {
						frameUrl: url
					}
				});
				dialogRef.afterClosed().subscribe(result => {
					if (result) location.reload();
				});

				break;
			default: return;
		}
    }

	async signInPrompt(args, workMode): Promise<any> {
		if (!this.appService.regionArgs.enableLogin || this.appService.user) return true;
		const signUpPrompt = await this.SignupPrompt(workMode);
		if (!signUpPrompt) throw ({});
		const loginResponse = await this.login(args, workMode);
		if (!loginResponse) throw ({});
		return loginResponse;
	}

	public login(args?, from = 'unknown', reloadAfterAnim = false): Promise<any> {
		this.appService.trackData('sign in click', {actionFrom: from})
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(LoginDialogComponent, {
				backdropClass: 'dialog-backdrop-dark',
				panelClass: 'rounded-dialog',
				direction: this.appService.direction,
				disableClose: true,
				autoFocus: false,
				maxWidth: "90vw",
				width: "310px",
				data: {
					...args, ...{ from: from }
				}
			});

			this.appService.positionDialogTop(dialogRef);
			dialogRef.afterClosed().subscribe(result => {
				if (result != undefined) {
					let user = this.appService.lUser;
					if (!args?.hideSuccessAnim && !result?.anonymous ) {
						this.appService.animDialog({
							title: this.appService.translate('WELCOME_BACK', {name: user.FullName}),
							animation: 'check',
							titleClass: 'text-lg text-center'
						}).then(() => {
							if (reloadAfterAnim) {
								document.location.reload();
							}
						});
					}
					resolve(result);
				} else {
					resolve(null);
				}
			});
		});
	}
	public showAccount(): Promise<any> {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(AccountDialogComponent, {
				panelClass: 'fullscreen-dialog',
				direction: this.appService.direction,
				disableClose: true,
				autoFocus: false,
				data: {}
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) location.reload();
			});
		});
	}
	public showHistory(): Promise<any> {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(HistoryDialogComponent, {
				panelClass: ['fullscreen-dialog', '_bg-light'],
				direction: this.appService.direction,
				disableClose: true,
				autoFocus: false,
				data: {}
			});
			dialogRef.afterClosed().subscribe(result => {

			});
		});
	}
	public showWallet(): Promise<any> {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(WalletDialogComponent, {
				panelClass: ['fullscreen-dialog', '_bg-light'],
				direction: this.appService.direction,
				disableClose: true,
				autoFocus: false,
				data: {}
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}



	public SignupPrompt(workMode = 'tabitPay') { // tabitPay, tabitOrder, addItems
		this.appService.trackData('sign in prompt shown');
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(SignupPromptDialogComponent, {
				width: "300px",
				backdropClass: 'dialog-backdrop-dark',
				panelClass: 'rounded-dialog',
				direction: this.appService.direction,
				data: { workMode: workMode},
				autoFocus: false
			});
			this.appService.positionDialogTop(dialogRef);
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					resolve(result);
					this.appService.trackData('sign in prompt approved');
				} else {
					this.appService.trackData('sign in prompt canceled');
					resolve(null);
				}
			});
		});
	}

	public passOrder(params?, fromCreate?) {
		return new Promise((resolve, reject) => {
			if (!params) params = this.appService.urlParams;
			this.appService.blockUI.start();
			this.entityService.get(`/online-shopper/orders/${params.oid}/links`, { source: 'tabitPay' }, { 'ros-organization': params.site }).then(links => {
				let dialogRef = this.dialog.open(PassorderDialogComponent, {
					backdropClass: 'dialog-backdrop-dark',
					panelClass: 'rounded-dialog',
					maxWidth: '90vw',
					direction: this.appService.direction,
					data: {
						link: links[0],
						fromCreate: fromCreate
					}
				});
				dialogRef.afterClosed().subscribe(result => { resolve({}); });
			}).catch(err => {
				this.appService.toastr('CANNOT_SEND_ORDER_BY_SMS', { type: 'error' });
				resolve({});
			}).then(ret => {
				this.appService.blockUI.stop();
			});
		});
	}

	public showBillDialog(args?) {
		let that = this;
		let dialogRef = this.dialog.open(OrderViewDialogComponent, {
			panelClass: ['fullscreen-dialog', '_bg-light'],
			data: args || {}
		});
		dialogRef.afterClosed().subscribe(result => { if (result != undefined) { } });
	}

	public payByOffersDialog(args?): Promise<any> {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(OfferSelectDialogComponent, {
				//panelClass: 'rounded-dialog',
				panelClass: 'fullscreen-dialog',
				data: args || {}
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result && result != "") {
					resolve(result);
				} else {
					reject(null);
				}
			});
		});
	}

	public manageOfferRequests(args?): Promise<any> {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(OfferRequestDialogComponent, {
				panelClass: 'fullscreen-dialog',
				data: args || {}
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}

	public showPaySuccessDialogs(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(PaySuccessDialogComponent, {
				panelClass: 'fullscreen-dialog',
				autoFocus: false,
				data: args || {}
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}

	public payByDinersDialog(args?): Promise<any> {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(PaybyDinersDialogComponent, {
				//panelClass: 'rounded-dialog',
				panelClass: 'fullscreen-dialog',
				data: args || {}
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result && result != "") {
					resolve(result);
				} else {
					reject(null);
				}
			});
		});
	}

	public openBillDialog(data: object) {
		return new Promise((resolve, reject) => {
            this.toggleActionFrame('bill', data, null);
		})
	}

	public showSMSDialog(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(SmsDialogComponent, {
				width: "300px",
				panelClass: 'rounded-dialog',
				direction: this.appService.direction,
				data: args,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result && result != "") {
					resolve(result);
				} else {
					reject(null);
				}
			});
		});
	}

	public showKeypadDialog(data: object, options?) {
		return new Promise((resolve, reject) => {
			const dialogRef = this.dialog.open(KeypadDialogComponent, {...{
				panelClass: 'rounded-dialog',
				data: data
			},...options});
			dialogRef.afterClosed().subscribe(result => {
				if (_.isObject(result) && result["wasChanged"] && result["amount"]) {
					resolve(result);
				}
			});

		})
	}

	public getTableNumber(args = {}) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(TableNumberDialogComponent, {
				maxWidth: "90vw",
				width: "310px",
				panelClass: 'rounded-dialog',
				backdropClass: 'dialog-backdrop-dark',
				direction: this.appService.direction,
				disableClose: true,
				autoFocus: false,
				data: args
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}

	public showTabOrderOptions_fromOrder($storage) {
		return this.showTabOrderOptions({
			title: this.appService.translate("OAT.tab_welocme", {v: $storage.config.name}),
			subTitle: this.appService.translate("OAT.tab_welocme_desc"),
			actions: [{
				id: 'solo',
				text: 'OAT.solo_order',
				description: 'OAT.solo_order_desc',
				image: '/assets/images/wallet.svg',
				icon: 'user-check'
			}]
		})
	}
	public showTabOrderOptions(config) {
		config.actions = config.actions.concat([
			{
				id: 'create',
				text: 'OAT.create_tab_order',
				description: 'OAT.create_tab_order_desc',
				image: '/assets/images/creditCard.svg',
				icon: 'users-medical'
			},
			{
				id: 'join',
				text: 'OAT.join_tab_order',
				description: 'OAT.join_tab_order_desc',
				image: '/assets/images/clientsSorting.svg',
				icon: 'users-viewfinder'
			}
		])
		return new Promise((resolve, reject) => {
			let bottomSheetRef = this.bottomSheet.open(TabOptionsBottomsheetComponent, {
				data: config,
				panelClass: "bottom-sheet-round",
				//disableClose: true
			});
			bottomSheetRef.afterDismissed().subscribe(response => {
				if (response) {
					switch (response["id"]) {
						case "create": this.router.navigate(['/taborder/create']); break;
						case "join": this.router.navigate(['/taborder/join']); break;
						default: resolve(true);
					}
				}
			});
		})
	}

	public openBottomSheet(data: object) {
		return new Promise((resolve, reject) => {
			let bottomSheetRef = this.bottomSheet.open(BottomSheetDialogComponent, {
				data: data,
				panelClass: "bottom-sheet-round",
				disableClose: true
			});
			bottomSheetRef.afterDismissed().subscribe(result => {
				resolve(result);
			});

			let canClose = false;
			bottomSheetRef.afterOpened().subscribe(result => {
				window.setTimeout(() => {
					canClose = true;
				}, 500);
			});
			bottomSheetRef.backdropClick().subscribe(result => {
				if (canClose) {
					bottomSheetRef.dismiss();
				}
			});
		})
	}

	public showCheckDialog(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(TabitpayCheckDialogComponent, {
				//width: "400px",
				maxWidth: "95vw",
				panelClass: 'rounded-dialog',
				disableClose: true,
				direction: this.appService.direction,
				data: args,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					resolve(result);
				} else {
					resolve(null);
				}
			});
		});
	}

	public showDinerDialog(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(TabitpayDinerDialogComponent, {
				//width: "400px",
				maxWidth: "95vw",
				panelClass: 'rounded-dialog',
				disableClose: true,
				direction: this.appService.direction,
				data: args,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					resolve(result);
				} else {
					resolve(null);
				}
			});
		});
	}

	openLoyaltyDialog(args?) { //openCheckoutDialog
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(OrderLoyaltyComponent, {
				//panelClass: 'kiosk-loyalty-dialog',
				maxWidth: "90vw",
				width: "310px",
				panelClass: 'rounded-dialog',
				backdropClass: 'dialog-backdrop-dark',

				disableClose: true,
				closeOnNavigation: false,
				data: {
					isInit: true,
					...args
				},
				autoFocus: false
			});
			this.appService.positionDialogTop(dialogRef);
			dialogRef.afterClosed().subscribe(result => {
				if (!result) result = {};
				if (result.mode == "register") {
					/*this.openLoyaltyRegister(result).then(_res => {
						resolve(_res || {});
					});*/
				}else resolve(result);
			});
		});
	}

	openLoyaltyPoints(args) { //openCheckoutDialog
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(OrderLoyaltyComponent, {
				maxWidth: "90vw",
				width: "310px",
				panelClass: 'rounded-dialog',
				backdropClass: 'dialog-backdrop-dark',
				direction: this.appService.direction,

				data: {
					mode: 'points',
					...args
				},
				autoFocus: false
			});
			this.appService.positionDialogTop(dialogRef);
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}


}
